import ToggleGroup from './ToggleGroup';

export default function ToggleGroupRow({ groups, children }) {
  return <>
    <div className="flex gap-1">
      {groups.map(({ props, options }) => <ToggleGroup
        key={props.name}
        options={options}
        {...props}
      />)}
      {children}
    </div>
  </>
}
